import { FC } from "react";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

interface EmptyWidgetMessageProps {
  loading?: boolean;
  error?: boolean;
  qesTestId: string;
}

const EmptyWidgetMessage: FC<EmptyWidgetMessageProps> = (props: EmptyWidgetMessageProps) => {
  if (props.loading) {
    return (
      <div className="pci-dashboard__empty-widget-content" data-testid={`${props.qesTestId}--loading`}>
        <QesIcon
          iconName={QesIcons.LoadingV1}
          isDecorative={true}
          className="qes-icon-spin pci-dashboard__empty-widget-loading-icon"
          height="32"
        />
        <div>Applying filters...</div>
      </div>
    );
  }

  if (props.error) {
    return (
      <div className="pci-dashboard__empty-widget-content" data-testid={`${props.qesTestId}--error`}>
        <div className="pci-dashboard__empty-widget-error-icon">
          <QesIcon iconName={QesIcons.AlertTriangle} isDecorative={true} className="align-text-top mr-1" height="30" />
        </div>
        <b>An error occurred while applying your filters</b>
        <div>Please try again.</div>
      </div>
    );
  }

  return (
    <div className="pci-dashboard__empty-widget-content" data-testid={`${props.qesTestId}--no-data`}>
      <div className="pci-dashboard__empty-widget-light-icon">
        <QesIcon iconName={QesIcons.FilterLines} isDecorative={true} className="align-text-top mr-1" height="30" />
      </div>
      <b>No providers match your filters</b>
      <div>There are no providers in this project for the current filter combination.</div>
    </div>
  );
};

export default EmptyWidgetMessage;
